import React, { FC, useLayoutEffect } from 'react';
import type { StepPageProps } from '../../../assessment-portal';
import { useAssessmentPortalState } from '../../../assessment-portal';
import type { AdhdFlowState } from '../../types/flow';
import { AdhdFlowStep } from '../../data/constants';
import {
  hasResolvableBookingConfirmation,
  resolveBookingConfirmationDisplay,
} from '../../utils/booking-confirmation-snapshot';
import BookingConfirmationPage from '../booking-confirmation-page';

const BookingConfirmationStep: FC<StepPageProps> = () => {
  const { flowState, goToStep } = useAssessmentPortalState<AdhdFlowState>();
  const canShowBookedPage = hasResolvableBookingConfirmation(flowState);

  useLayoutEffect(() => {
    if (!canShowBookedPage) {
      goToStep(AdhdFlowStep.WELCOME);
    }
  }, [canShowBookedPage, goToStep]);

  if (!canShowBookedPage) {
    return null;
  }

  const {
    firstName,
    clinicianName,
    clinicianTitle,
    startDateTime,
  } = resolveBookingConfirmationDisplay(flowState);

  return (
    <BookingConfirmationPage
      firstName={firstName}
      clinicianName={clinicianName}
      clinicianTitle={clinicianTitle}
      startDateTime={startDateTime}
    />
  );
};

export default BookingConfirmationStep;
